import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import ClientWiseSummaryPageUI from './ClientWiseSummaryPageUI.js'

const getCurrentYearMonth = () => {
  const now = new Date()
  return { year: now.getFullYear(), month: now.getMonth() + 1 }
}

const shiftYearMonth = (year, month, delta) => {
  const date = new Date(year, month - 1 + delta, 1)
  return { year: date.getFullYear(), month: date.getMonth() + 1 }
}

const formatYearMonth = (year, month) => {
  const date = new Date(year, month - 1, 1)
  return date.toLocaleDateString('en-IN', { month: 'long', year: 'numeric' })
}

class ClientWiseSummaryPageSF extends Component {
  constructor(props) {
    super(props)
    const { year, month } = getCurrentYearMonth()
    this.state = {
      errorList: null,
      accountSummaryList: null,
      txnSummaryTotalList: null,
      startDateISO: null,
      endDateISO: null,
      loading: true,
      downloadMode: false,
      year,
      month,
      isCurrentMonth: true,
    }
  }

  render() {
    return (
      <ClientWiseSummaryPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        accountNumber={this.props.match.params.accountNumber}
        accountSummaryList={this.state.accountSummaryList}
        loading={this.state.loading}
        onRefreshClick={this.onRefreshClick}
        downloadMode={this.state.downloadMode}
        onDownloadClick={this.onDownloadClick}
        yearMonthLabel={formatYearMonth(this.state.year, this.state.month)}
        isCurrentMonth={this.state.isCurrentMonth}
        onPreviousClick={this.onPreviousClick}
        onNextClick={this.onNextClick}
      />
    )
  }

  componentDidMount() {
    this.loadSummary(this.props.context, this.props.match.params.accountNumber, this.state.year, this.state.month)
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.accountNumber !== prevProps.match.params.accountNumber) {
      this.loadSummary(this.props.context, this.props.match.params.accountNumber, this.state.year, this.state.month)
    }
  }

  loadSummary(context, accountNumber, year, month) {
    const current = getCurrentYearMonth()
    this.setState({
      loading: true,
      errorList: null,
      accountSummaryList: null,
      txnSummaryTotalList: null,
      startDateISO: null,
      endDateISO: null,
      isCurrentMonth: year === current.year && month === current.month,
    }, () => {
      this.getClientWiseSummary(context, accountNumber, year, month)
    })
  }

  getClientWiseSummary(context, accountNumber, year, month) {
    const cacheManager = new CacheManager({
      resource: `/api/su/nodalBankAccounts/${accountNumber}/bankTransactions/clientWiseSummary`,
      cacheKey: CacheKeys.ClientWiseSummary(accountNumber, year, month),
      callback: this.getClientWiseSummaryCallback,
      ttlInSecs: 240
    })
    cacheManager.getObject2(context, {}, { year, month })
  }

  getClientWiseSummaryCallback = (response) => {
    this.setState({
      loading: false,
      errorList: response.errorList,
      accountSummaryList: response.accountSummaryList || [],
      txnSummaryTotalList: response.txnSummaryTotalList,
      startDateISO: response.startDateISO,
      endDateISO: response.endDateISO,
    })
  }

  onPreviousClick = (e) => {
    e.preventDefault()
    const { year, month } = shiftYearMonth(this.state.year, this.state.month, -1)
    this.setState({ year, month })
    this.loadSummary(this.props.context, this.props.match.params.accountNumber, year, month)
  }

  onNextClick = (e) => {
    e.preventDefault()
    if (this.state.isCurrentMonth) return
    const { year, month } = shiftYearMonth(this.state.year, this.state.month, 1)
    this.setState({ year, month })
    this.loadSummary(this.props.context, this.props.match.params.accountNumber, year, month)
  }

  onRefreshClick = () => {
    const { accountNumber } = this.props.match.params
    const cacheKey = CacheKeys.ClientWiseSummary(accountNumber, this.state.year, this.state.month)
    CacheManager.removeObject(cacheKey)
    localStorage.removeItem(`${cacheKey}:CachedTime`)
    this.loadSummary(this.props.context, accountNumber, this.state.year, this.state.month)
  }

  onDownloadClick = () => {
    this.setState({ downloadMode: true })
    RestApiUtils.get(
      this.props.context,
      `/api/su/nodalBankAccounts/${this.props.match.params.accountNumber}/bankTransactions/excel/fileDownloadSignedUrl?year=${this.state.year}&month=${this.state.month}`,
      this.onDownloadClickCallback,
      null,
      null
    )
  }

  onDownloadClickCallback = (response) => {
    this.setState({ downloadMode: false, errorList: response.errorList })
    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}

export default withRouter(ClientWiseSummaryPageSF)
